module.exports = __webpack_public_path__ + "static/img/v2_qkciaf.dff644a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/practice/assets/img/v2_qkciaf.svg
// module id = eqlJ
// module chunks = 1